// extracted by mini-css-extract-plugin
export default {"container":"Products_container__Un222","products":"Products_products__-41Gc","menu":"Products_menu__W6iGC","list":"Products_list__R4CCJ","product":"Products_product__1aCZN"};